module.exports = __webpack_public_path__ + "static/img/excel.40fc5c3b.png";